import { FC, Children } from 'react';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ExpandMore } from '@mui/icons-material';
import ContentRenderer from '../Content/ContentRenderer';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import './Hint.scss';

type HintProps = {
	field: IEntityContentField;
	children?: any;
};

const Hint: FC<HintProps> = ({ field, children }) => (
	<div className="hint">
		<Accordion elevation={0}>
			<AccordionSummary expandIcon={<ExpandMore />}>
				{/* <InfoOutlinedIcon color="primary" style={{ marginRight: '5px' }} /> */}
				{field.options.label}
			</AccordionSummary>
			<AccordionDetails>
				<ContentRenderer html={field.content} key={field.name} />
				{Children.map(children, (child) => (
					<div className="Row">{child}</div>
				))}
			</AccordionDetails>
		</Accordion>
	</div>
);

export default Hint;
